module.exports = __webpack_public_path__ + "img/male.233dc825.svg";